import { c as _c } from "react/compiler-runtime";
import { useRoleXgSeat } from "@hooks/use-role-xg-seat";
import { FaroCoreApiConst } from "@stellar/core-api-client";
import { ProjectMemberEvents } from "@utils/track-event/track-event-list";
import { doesProjectRoleNeedXgSeat } from "@utils/invite-xg-seat-utils";

/** The project roles that can be assigned, which is all but the owner */

/** Whether a project role can be assigned through a role change, which the owner cannot */
function isAssignableProjectRole(role) {
  return role !== "RESOURCE_OWNER";
}

/** The project roles that need a Sphere XG seat, see doesProjectRoleNeedXgSeat */
export const PROJECT_ROLE_XG_SEAT = {
  xgSeatRoles: FaroCoreApiConst.allProjectRoles.filter(isAssignableProjectRole).filter(role => doesProjectRoleNeedXgSeat(role)),
  viewerRole: "RESOURCE_VIEWER",
  events: ProjectMemberEvents
};

/**
 * Applies the Sphere XG seats to changing the role of a project member, see useRoleXgSeat. On a
 * Scan plan, only members holding a seat can be a project role other than viewer.
 */
export function useProjectRoleXgSeat(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = {
      ...props,
      subject: PROJECT_ROLE_XG_SEAT
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useRoleXgSeat(t0);
}